<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Corrección de facturas</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md4>
                <empresa-select v-model="empresa"></empresa-select>
            </v-flex>
            <v-flex xs12 md4>
                <v-text-field label="Serie" v-model="serie"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
                <v-text-field label="Factura" v-model="factura"></v-text-field>
            </v-flex>
            <v-flex>
                <v-btn color="green" dark @click="getData" :loading="loadingData">Obtener datos</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <pre>{{ xml }}</pre>
            </v-flex>
            <v-flex>
                <v-layout>
                    <v-text-field label="ImpTotal => F2_VALBRUT" v-model="d.F2_VALBRUT" class="flex"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALBRUT"></v-checkbox>
                    <v-text-field label="ImpNeto => F2_VALMERC" v-model="d.F2_VALMERC" class="flex"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALMERC"></v-checkbox>
                    <v-text-field label="F2_VALFAT" v-model="d.F2_VALFAT" class="flex"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALFAT"></v-checkbox>
                </v-layout>
                <v-layout>
                    <v-text-field class="flex" label="ImpIVA => F2_VALIMP1" v-model="d.F2_VALIMP1"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALIMP1"></v-checkbox>
                    <v-text-field class="flex" label="BASE ImpIVA => F2_BASIMP1" v-model="d.F2_BASIMP1"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_BASIMP1"></v-checkbox>
                </v-layout>
                <v-layout>
                    <v-text-field class="flex" label="F2_VALIMP2" v-model="d.F2_VALIMP2"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALIMP2"></v-checkbox>
                    <v-text-field class="flex" label="F2_BASIMP2" v-model="d.F2_BASIMP2"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_BASIMP2"></v-checkbox>
                </v-layout>
                <v-layout>
                    <v-text-field class="flex" label="F2_VALIMP3" v-model="d.F2_VALIMP3"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALIMP3"></v-checkbox>
                    <v-text-field class="flex" label="F2_BASIMP3" v-model="d.F2_BASIMP3"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_BASIMP3"></v-checkbox>
                </v-layout>
                <v-layout>
                    <v-text-field class="flex" label="F2_VALIMP4" v-model="d.F2_VALIMP4"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALIMP4"></v-checkbox>
                    <v-text-field class="flex" label="F2_BASIMP4" v-model="d.F2_BASIMP4"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_BASIMP4"></v-checkbox>
                </v-layout>
                <v-layout>
                    <v-text-field class="flex" label="F2_VALIMP5" v-model="d.F2_VALIMP5"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALIMP5"></v-checkbox>
                    <v-text-field class="flex" label="F2_BASIMP5" v-model="d.F2_BASIMP5"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_BASIMP5"></v-checkbox>
                </v-layout>
                <v-layout>
                    <v-text-field class="flex" label="PERC.INGR.BRUTO => F2_VALIMP6" v-model="d.F2_VALIMP6"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_VALIMP6"></v-checkbox>
                    <v-text-field class="flex" label="BASE PERC.INGR.BRUTO=> F2_BASIMP6" v-model="d.F2_BASIMP6"></v-text-field>
                    <v-checkbox class="flex" v-model="edit" value="F2_BASIMP6"></v-checkbox>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout>
            <v-flex>
                <v-btn color="green" dark @click="procesar">Procesar</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EmpresaSelect from "../../components/EmpresaSelect";
    import {mapActions} from "vuex";
    import moneda from "../../filters/moneda";

    export default {
        name: "pedido_libera",
        components: {EmpresaSelect},
        data() {
            return {
                serie: 'A17',
                factura: '000700010172',
                empresa: '3',
                loadingData: false,
                edit: [],
                d: {
                    F2_VALFAT: 0,
                    F2_VALBRUT: 0,
                    F2_VALMERC: 0,
                    F2_VALIMP1: 0,
                    F2_VALIMP2: 0,
                    F2_VALIMP3: 0,
                    F2_VALIMP4: 0,
                    F2_VALIMP5: 0,
                    F2_VALIMP6: 0,
                    F2_BASIMP1: 0,
                    F2_BASIMP2: 0,
                    F2_BASIMP3: 0,
                    F2_BASIMP4: 0,
                    F2_BASIMP5: 0,
                    F2_BASIMP6: 0
                },
                xml: ''
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            getData() {
                this.loadingData = true;
                this.$http.post('varios/factura-fix/datos', {
                    factura: this.factura,
                    serie: this.serie,
                    empresa: this.empresa
                })
                    .then(r => {
                        this.d = r.data.fat;
                        this.xml = r.data.xml;
                        this.loadingData = false;
                    })
                    .catch(err => {
                        this.loadingData = false;
                    })
            },
            procesar() {
                this.loading = true;
                this.$http.post('varios/factura-fix/procesar', {
                    factura: this.factura,
                    serie: this.serie,
                    empresa: this.empresa,
                    edit: this.edit,
                    campos: this.d
                })
                    .then(r => {
                        this.msjShow(r.data);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/varios/factura_fix.vue